module.exports = __webpack_public_path__ + "static/media/hull_color_style_0003.dc10dc04.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hullColors/hull_color_style_0003.jpg
// module id = 621
// module chunks = 0